// FAQ
$(document).ready(function ($) {
  $(".faq-wrap").on("click", function (e) {
    e.preventDefault();
    // Aberto
    if ($(this).hasClass("aberto")) {
      $(this).removeClass("aberto");
      $(".resposta-wrap", this).slideUp();
    } else {
      // Fechado
      $(this).addClass("aberto");
      $(".resposta-wrap", this).slideDown();
    }
  });
});
